// find the topmost element containing share this links if in view load js
(() => {
    var shareThisContainer = $("[data-shareThis]");
    if(shareThisContainer.length == 0) 
        return;
    var shareThisLoaded = false;
    const desktopHeaderHeight = $("nav").height();
    const apiKey  = document.querySelector("link[href*='sharethis'").href;
    // for widget containing sharethis in view on load
    lazyLoadShareThis();
    function lazyLoadShareThis() {
      var widgetScrollDistance = shareThisContainer.offset().top;
      var scrollDistance = $(window).scrollTop();
      var windowHeight = $(window).height();
  
      if (
        scrollDistance >= (widgetScrollDistance - windowHeight - desktopHeaderHeight) &&
        !shareThisLoaded
      ) {
          $("head").append(
            `<script src="${apiKey}"></script>`
          );
        shareThisLoaded = true;
        window.removeEventListener("scroll", lazyLoadShareThis);
      }
    }
  
    window.addEventListener("scroll", lazyLoadShareThis ,{passive: true})
  
  })();
  